import { editSchoolUser, getUsersBySchool, removeTeamMembers } from '../../services/SchoolService'
import { inviteUser, resendInvitation } from '../../services/UserService'
import { isError } from '../../utils/api'
import { teamMembersStatus, userPrimaryRoles } from '../../utils/constants'
import { deepCopy } from '../../utils/object'

export default {
  state: {
    allUsers: {
      users: [],
      totalCount: 0
    },
    selectedUsers: []
  },

  mutations: {
    selectTeamUser(state, user) {
      state.selectedUsers.push(user)
    },
    selectAllTeamUsers(state, role) {
      if (role === userPrimaryRoles.admin) {
        state.selectedUsers = deepCopy(state.allUsers.users)
      } else {
        state.selectedUsers = deepCopy(state.allUsers.users.filter(user => user.role === userPrimaryRoles.teacher))
      }
    },
    deselectTeamUser(state, user) {
      const newUsers = state.selectedUsers.filter(selUser => selUser.userId !== user.userId)
      state.selectedUsers = newUsers
    },
    deselectAllTeamUsers(state) {
      state.selectedUsers = []
    },
    setUsersInTeam(state, { data, totalCount }) {
      state.allUsers.users = data.map(user => ({ ...user, invitationSent: false }))
      state.allUsers.totalCount = totalCount
    },
    clearTeamUsers(state) {
      state.allUsers.users = []
      state.selectedUsers = []
    },
    addInvitationSent(state, id) {
      if (id.length) {
        state.allUsers.users = state.allUsers.users.map(user => id.includes(user.userId) ? ({ ...user, invitationSent: true }) : user)
      } else {
        const index = state.allUsers.users.findIndex(user => user.userId === id)
        state.allUsers.users[index].invitationSent = true
      }
    }
  },

  actions: {
    selectTeamUser({ commit }, user) {
      commit('selectTeamUser', user)
    },
    selectAllTeamUsers({ commit }, userRole) {
      commit('selectAllTeamUsers', userRole)
    },
    deselectTeamUser({ commit }, user) {
      commit('deselectTeamUser', user)
    },
    deselectAllTeamUsers({ commit }) {
      commit('deselectAllTeamUsers')
    },
    clearTeamUsers({ commit }) {
      commit('clearTeamUsers')
    },
    async sendInvitations({ commit }, data) {
      const response = await inviteUser(data).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      return successfulRequest
    },
    async getUsersInSchool({ commit }, { id, filters = {} }) {
      const response = await getUsersBySchool({ id, filters }).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      if (successfulRequest) commit('setUsersInTeam', response.data)
      return successfulRequest
    },
    async resendInvitations({ commit, state }, schoolId) {
      const ids = state.selectedUsers
        .filter(user => user.invitationStatus.toLowerCase() !== teamMembersStatus.confirmed)
        .map(user => user.userId)
      const response = await resendInvitation(schoolId, ids).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      if (successfulRequest) {
        commit('addInvitationSent', ids)
        commit('deselectAllTeamUsers')
      }
      return successfulRequest
    },
    async resendInvitation({ commit }, { schoolId, id }) {
      const response = await resendInvitation(schoolId, [id]).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      if (successfulRequest) commit('addInvitationSent', id)
      return successfulRequest
    },
    async deleteUsers({ commit, state }, schoolId) {
      const ids = state.selectedUsers.map(user => user.userId)
      const response = await removeTeamMembers(schoolId, ids).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      if (successfulRequest) commit('deselectAllTeamUsers')
      return successfulRequest
    },
    async editSchoolUser({ commit }, { schoolId, userData }) {
      const response = await editSchoolUser(schoolId, userData).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      if (successfulRequest) { return successfulRequest }
    }
  }
}
